/**
 * 지도에서 실제 위치로 표시할 수 있는 위경도인지 검증합니다.
 */
export function isRenderableLatLon(lat: unknown, lon: unknown): boolean {
  return (
    typeof lat === 'number' &&
    typeof lon === 'number' &&
    Number.isFinite(lat) &&
    Number.isFinite(lon) &&
    !(lat === 0 && lon === 0) &&
    lat >= -90 &&
    lat <= 90 &&
    lon >= -180 &&
    lon <= 180
  );
}

/**
 * 위경도 보유 객체가 지도 표시 가능한 좌표를 갖는지 확인합니다.
 */
export function hasRenderableCoordinates<T extends { lat?: unknown; lon?: unknown }>(item: T): item is T & { lat: number; lon: number } {
  return isRenderableLatLon(item.lat, item.lon);
}

/**
 * 배열 또는 문자열 입력에서 지도 표시 가능한 위경도 쌍을 추출합니다.
 */
export function normalizeLatLonPair(lat: unknown, lon: unknown): { lat: number; lon: number } | null {
  const normalizedLat = typeof lat === 'string' && lat.trim().length > 0 ? Number(lat) : lat;
  const normalizedLon = typeof lon === 'string' && lon.trim().length > 0 ? Number(lon) : lon;
  if (!isRenderableLatLon(normalizedLat, normalizedLon)) {
    return null;
  }

  return { lat: normalizedLat as number, lon: normalizedLon as number };
}
